import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '../../core/core.module';
import { LanguagesComponent } from './languages.component';
import { SharedModule } from '../shared.module';


@NgModule({
  declarations: [
    LanguagesComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    SharedModule
  ],
  exports: [
    LanguagesComponent
  ]
})
export class LanguagesModule { }
